import { render, staticRenderFns } from "./twoColumn.vue?vue&type=template&id=02b73088&scoped=true&"
import script from "./twoColumn.vue?vue&type=script&lang=js&"
export * from "./twoColumn.vue?vue&type=script&lang=js&"
import style0 from "./twoColumn.vue?vue&type=style&index=0&id=02b73088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b73088",
  null
  
)

export default component.exports